const button = "_b7nbem179y";

export { button };
import "./atom.chevrons.style.linaria.module.css";
//# sourceMappingURL=atom.chevrons.style.js.map
